module.exports = __webpack_public_path__ + "img/brick_logo.b4310fe3.png";